import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { DIALOG_TEXT_CONSTANTS } from '../../../shared/constants';
import { AppTextButtonComponent } from '../../buttons/app-text-button/app-text-button.component';

@Component({
    selector: 'kh-upload-progress-dialog',
    templateUrl: './upload-progress-dialog.component.html',
    styleUrls: ['./upload-progress-dialog.component.scss'],
    imports: [
        AppTextButtonComponent,
        MatDialogActions,
        MatDialogContent,
        MatProgressSpinner
    ]
})
export class UploadProgressDialogComponent {

    cancelUploadLabel = DIALOG_TEXT_CONSTANTS.CANCEL_UPLOAD;
    progressMessage = DIALOG_TEXT_CONSTANTS.UPLOAD_PROGRESS_MESSAGE;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: string,
        private _dialogRef: MatDialogRef<UploadProgressDialogComponent>,
    ) { }

    cancelUpload(): void {
        this._dialogRef.close(true);
    }
}
